import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'

export default function PieChart({
  compStyle = { height: '400px', width: '100%' },
  seriesData = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  console.log('seriesData => ', seriesData)

  const optionChart = {
    // title: {
    //   text: 'Referer of a Website',
    //   subtext: 'Fake Data',
    //   left: 'center',
    // },
    tooltip: {
      trigger: 'item',
    },
    // legend: {
    //   orient: 'vertical',
    //   left: 'left',
    // },
    series: [
      {
        name: '',
        type: 'pie',
        radius: '70%',
        data: seriesData,
        // data: [
        //   {
        //     value: 46.67,
        //     name: 'สถาบันวิจัยและศูนย์วิชาการ เช่น มหาวิทยาลัย วิทยาลัย สถาบันวิจัยและศูนย์วิชาการ โรงเรียน สถานศึกษาในทุกระบดับ 21 (46.67%)',
        //   },
        //   {
        //     value: 26.67,
        //     name: 'ภาคราชการ (Government Sector) เช่น กระทรวง ทบวง กรม หน่อยงานส่วนภูมิภาค/ท้องถิ่น (อบจ., อบต., เทศบาล) 12 (26.67%)',
        //   },
        //   {
        //     value: 2.22,
        //     name: 'ภาคประชาสังคม (Civil Society Sector) เช่น สมาคม มูลนิธิ เครือข่ายจิตอาสา ชมรมและองค์กรภาคประชาชน 1 (2.22%)',
        //   },
        //   { value: 22.22, name: 'อื่นๆ เช่น นักวิชาการอิสระ 10 (22.22%)' },
        // ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
